import { ControleEstoqueListaRequest } from './controle-estoque-lista.request';

export class ControleEstoqueInventarioPrintRequest extends ControleEstoqueListaRequest {
  idLocalizacaoEstoque?: number | null;
  exibirSaldoAtual?: boolean;
}
